import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncViewAnnouncement({ ...rest }) {
  const AsyncLoad = loadable(() => import("../page/viewAnnouncement"));
  console.log("Loading", AsyncViewAnnouncement.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncViewAnnouncement;
